import { OPENAI_PIXEL_ID } from './marketingPixelConfig.js';

/**
 * @param {{ planId?: string, eventId?: string }} [payload]
 */
function trackOpenAiTrialStarted(payload = {}) {
  const oaiq = window.oaiq;
  if (typeof oaiq !== 'function') {
    return;
  }

  const planId = String(payload.planId || 'free_trial').trim() || 'free_trial';
  const eventId = String(payload.eventId || '').trim();
  const options = eventId ? { event_id: eventId } : undefined;

  oaiq(
    'measure',
    'trial_started',
    {
      type: 'plan_enrollment',
      plan_id: planId,
    },
    options
  );
}

/**
 * Fires trial-start conversion signals (OpenAI Ads). No-ops when the pixel is not loaded.
 * @param {{ planId?: string, eventId?: string }} [payload]
 */
export function trackTrialStarted(payload = {}) {
  if (typeof window === 'undefined') {
    return;
  }

  if (!OPENAI_PIXEL_ID) {
    return;
  }

  trackOpenAiTrialStarted(payload);
}
